module.exports = __webpack_public_path__ + "static/media/Defillama.79133807.png";